<section class="page-wrapper">
    <div class="fixture-section margin-top-152 cf">
       <div class="container">
          <div class="fixture-hero-detail cf">
             <div class="fixture-hero-titel">
                <div class="fixture-hero-titel-inner">
                   <h2>FIXTURES &amp; RESULTS</h2>
                </div>
             </div>
             <!--bindings={
                "ng-reflect-ng-if": "false"
                }-->
          </div>
       </div>
       <div class="fixture-vector-image">
          <div class="fixture-vector-image-inner"><img src="assets/images/ic-logo.png"></div>
       </div>
    </div>
    <div class="fixture-season-section cf">
       <div class="container">
          <div class="fixture-season-detail">
             <ul> 
                <li>
                   <a href="javascript:void(0)">
                      <select class="select_tab">
                         <optgroup>
                           <option value="{{season?.season_type_id}}" class="{{i}}"
                                        *ngFor="let season of seasonList?.data; let i = index">{{season?.title}} Season
                                    </option>
                         </optgroup>
                      </select>
                   </a>
                </li>
             </ul>
          </div>
       </div>
      
       <div class="fixture-season-tab-section  fixture-new-arrows cf">
          <div class="fixture-season-tab-detail">
             <ul class="maintab">
                
                <li class="courses-name" [ngClass]="{ active: i == 0 }" id="tab-{{maincat?.series_type_id}}"
                *ngFor="let maincat of matchesnewList?.data; let i = index"><a href="javascript:void(0)">{{maincat?.title}}</a></li>
                <!-- <li class="courses-name" ng-reflect-klass="courses-name" ng-reflect-ng-class="[object Object]" id="tab-2"><a href="javascript:void(0)">Second XI Fixtures</a></li>
                <li class="courses-name" ng-reflect-klass="courses-name" ng-reflect-ng-class="[object Object]" id="tab-5"><a href="javascript:void(0)">Women's Fixtures</a></li> -->
             </ul>
          </div>
         
          <div class="fixture-season-tab-content-detail course-main-content cf " [ngClass]="{ active: i == 0 }"  id="tab-{{maincat?.series_type_id}}-content"
          *ngFor="let maincat of matchesnewList?.data; let i = index">
             <div class="fixture-season-tab-inner">
                <div class="container">
                   <div class="fixture-season-tab-inner-detail">
                      <ul class="maintab-inner">
                        <li class="inner-name active" id="subtab-{{maincat?.series_type_id}}"><a href="javascript:void(0)">ALL</a></li>
                         <li class="inner-name"  
                         id="subtab-{{subcat?.series_catagory_id}}"
                         *ngFor="let subcat of maincat?.series_catagory; let i = index"><a href="javascript:void(0)">{{subcat?.title}}</a></li>
                         
                      </ul>
                   </div>
                   <div class="fixture-season-tab-inner-detail-content inner-main-content active"  id="subtab-{{maincat?.series_type_id}}-content">
                      <div class="container">
                         <div class="fixture-season-tab-content-top">
                            <div class="fixture-season-tab-celender">
                              <div class="celender-box">
                                 <div class="row text-center">
                                     <div class="col-md-4">
                                         <div class="btn-group">
                                             <div class="btn btn-primary Previous" mwlCalendarPreviousView
                                                 [view]="view" [(viewDate)]="viewDate"> </div>
                                             <div class="btn btn-outline-secondary" mwlCalendarToday
                                                 [(viewDate)]="viewDate"></div>
                                             <div class="btn btn-primary next" mwlCalendarNextView
                                                 [view]="view" [(viewDate)]="viewDate"></div>
                                         </div>
                                     </div>
                                     <div class="month-name">
                                         <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                                     </div>
                                     <div class="calendarmenu">
                                         <!--<ul>
                                             <li class="menu-team-top">
                                                 <a [href]="googleCalendarEventUrl" target="_blank">Add To Calender</a>
                                             </li>
                                         </ul>-->

                                     </div>
                                 </div>
                                 <br />
                                 <div *ngIf="events$ | async;  let events">
                                     <div [ngSwitch]="view">
                                         <mwl-calendar-month-view *ngSwitchCase="'month'"
                                             [viewDate]="viewDate" [events]="events"
                                             [activeDayIsOpen]="activeDayIsOpen"
                                             (dayClicked)="dayClicked($event.day)"
                                             (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-month-view>
                                         <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
                                             [events]="events" (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-week-view>
                                         <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
                                             [events]="events" (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-day-view>
                                     </div>
                                 </div>

                              </div>
                            </div>
                            <div class="fixture-season-tab-matches">
                               <div class="second-fixtures-detail-tab">
                                  <div class="second-fixtures-detail-tab-list">
                                     <ul class="subtab">
                                        <li class="fixtures-name ok" id="upcoming-{{maincat?.series_type_id}}1"><a href="#" id="Upcoming">Upcoming Matches</a></li>
                                        <li class="fixtures-name " id="past-{{maincat?.series_type_id}}1"><a href="#" id="Past">Past Matches</a></li>
                                     </ul>
                                  </div>
                               </div>
                               <div class="second-fixtures-detail-tab-detail fixtures-main-content ok" id="upcoming-{{maincat?.series_type_id}}1-content">
                                    <div class="leicester-match-section cf">
                                        <div class="leicester-match-box" *ngFor="let upcoming of maincat?.all_upcoming" [ngStyle]="{'background-image':'url(' + upcoming?.image + ')'}">
                                            <div class="leicester-match-box-first">
                                               <h3>{{upcoming?.date_time | amDateFormat: "ddd"}}</h3>
                                               <h2>{{upcoming?.date_time | amDateFormat: "DD MMM"}}</h2>
                                               <h3>{{upcoming?.date_time |
                                                amDateFormat: "HH : mm a"}}</h3>
                                               <p>{{upcoming?.series_catagory_title}}</p>
                                            </div>
                                            <div class="leicester-match-box-left">
                                                <div class="leicester-match-box-left-logo-box">
                                                     <div class="leicester-match-left">
                                                         <div class="leicester-match-left-image">  
                                                            <img [src]="upcoming?.first_image">
                                                         </div>
                                                         <div class="leicester-match-left-team">
                                                            <h3>{{upcoming?.first_name}}</h3>
                                                         </div>
                                                      </div>
                                                      <div class="leicester-match-right">
                                                         <div class="leicester-match-left-image">  
                                                           <img [src]="upcoming?.second_image">
                                                         </div>
                                                         <div class="leicester-match-left-team">
                                                            <h3>{{upcoming?.second_name}}</h3>
                                                         </div>
                                                      </div>
                                                </div>
                                                <div class="leicester-match-box-left-content">
                                                      <p>{{upcoming?.location}}</p>
                                                </div>
                                            </div>
                                            <div class="leicester-match-box-right">
                                                <div class="leicester-match-box-right-btn">
                                                   <a href="{{upcoming?.redirect_url}}" target="_blank" *ngIf="upcoming?.redirect_url">Buy Tickets</a>
                                                   <a href="{{upcoming?.match_day_hospitality_url}}" target="_blank" *ngIf="upcoming?.match_day_hospitality_url">BUY HOSPITALITY</a>
                                                </div>
                                            </div>
                                            <div class="leicester-match-overlay"></div>
                                        </div>     
                                                                                
                                    </div>
                               </div>
                               <div class="second-fixtures-detail-tab-detail fixtures-main-content " id="past-{{maincat?.series_type_id}}1-content">
                                  <div class="leicester-match-section cf">
                                    <div class="leicester-match-box" *ngFor="let past of maincat?.all_past" [ngStyle]="{'background-image':'url(' + past?.image + ')'}">
                                       <div class="leicester-match-box-first">
                                          <h3>{{past?.date_time | amDateFormat: "ddd"}}</h3>
                                          <h2>{{past?.date_time | amDateFormat: "DD MMM"}}</h2>
                                          <h3>{{past?.date_time |
                                           amDateFormat: "HH : mm a"}}</h3>
                                          <p>{{past?.series_catagory_title}}</p>
                                          <p *ngIf="past?.result">{{past?.result}}</p>
                                       </div>
                                       <div class="leicester-match-box-left">
                                           <div class="leicester-match-box-left-logo-box">
                                                <div class="leicester-match-left">
                                                    <div class="leicester-match-left-image">  
                                                       <img [src]="past?.first_image">
                                                    </div>
                                                    <div class="leicester-match-left-team">
                                                       <h3>{{past?.first_name}}</h3>
                                                    </div>
                                                 </div>
                                                 <div class="leicester-match-right">
                                                    <div class="leicester-match-left-image">  
                                                      <img [src]="past?.second_image">
                                                    </div>
                                                    <div class="leicester-match-left-team">
                                                       <h3>{{past?.second_name}}</h3>
                                                    </div>
                                                 </div>
                                           </div>
                                           <div class="leicester-match-box-left-content">
                                                 <p>{{past?.location}}</p>
                                           </div>
                                       </div>
                                       <div class="leicester-match-box-right">
                                           <div class="leicester-match-box-right-btn past" *ngIf="past?.series_type == 'TEST'">
                                             <a href="{{past?.day_1_url}}" target="_blank" *ngIf="past?.day_1_url">Day 1</a>
                                             <a href="{{past?.day_2_url}}" target="_blank" *ngIf="past?.day_2_url">Day 2</a>
                                             <a href="{{past?.day_3_url}}" target="_blank" *ngIf="past?.day_3_url">Day 3</a>
                                             <a href="{{past?.day_4_url}}" target="_blank" *ngIf="past?.day_4_url">Day 4</a>
                                              
                                           </div>
                                           <div class="leicester-match-box-right-btn past singlebtn" *ngIf="past?.series_type == 'T20' || past?.series_type == 'ODI'">
                                             <a href="{{past?.day_1_url}}" target="_blank" *ngIf="past?.day_1_url">Match Report</a>
                                             <a href="{{past?.day_2_url}}" target="_blank" *ngIf="past?.day_2_url">Match Report</a>
                                             <a href="{{past?.day_3_url}}" target="_blank" *ngIf="past?.day_3_url">Match Report</a>
                                             <a href="{{past?.day_4_url}}" target="_blank" *ngIf="past?.day_4_url">Match Report</a>
                                              
                                           </div>
                                       </div>
                                       <div class="leicester-match-overlay"></div>
                                    </div> 
                                     
                                   
                                  </div>
                               </div>
                            </div>
                         </div>
                         <div class="fixture-season-tab-content-bottom cf" *ngIf="contentList">
                            <div class="fixture-season-tab-content-bottom-detail">
                               <div class="fixture-season-tab-content-image" *ngIf="contentList?.image"><img [src]="contentList?.image"></div>
                               <div class="fixture-season-tab-content-text">
                                  <h2 *ngIf="contentList?.title"> {{contentList?.title}}</h2>
                                  <h4 *ngIf="contentList?.sub_title"> {{contentList?.sub_title}}</h4>
                                  <div class="fixture-season-content-text" [innerHTML]="contentList?.description">
                                     <p> Leicestershire County Cricket Club announce the 2021 membership offering as part of the #ANewBreed campaign. A New Breed of Fox emphasises the new chapter of the club, both on and off the pitch. </p>
                                     <p> 2021 Memberships launch off the back of an encouraging 2020 season whereby, the Running Foxes reached the Quarter Finals of the Vitality Blast for the first time in 3 years. </p>
                                  </div>
                                  <div class="fixture-season-tab-content-text-btn" *ngIf="contentList?.button_url || contentList?.button_name"><a href="{{contentList?.button_url}}" target="_blank">{{contentList?.button_name}}</a></div>
                               </div>
                            </div>
                         </div>
                      </div>
                   </div>
                   <div class="fixture-season-tab-inner-detail-content inner-main-content "  id="subtab-{{subcat?.series_catagory_id}}-content"
                   *ngFor="let subcat of maincat?.series_catagory; let i = index">
                      <div class="container">
                         <div class="fixture-season-tab-content-top">
                            <div class="fixture-season-tab-celender">
                              <div class="celender-box">
                                 <div class="row text-center">
                                     <div class="col-md-4">
                                         <div class="btn-group">
                                             <div class="btn btn-primary Previous" mwlCalendarPreviousView
                                                 [view]="view" [(viewDate)]="viewDate"> </div>
                                             <div class="btn btn-outline-secondary" mwlCalendarToday
                                                 [(viewDate)]="viewDate"></div>
                                             <div class="btn btn-primary next" mwlCalendarNextView
                                                 [view]="view" [(viewDate)]="viewDate"></div>
                                         </div>
                                     </div>
                                     <div class="month-name">
                                         <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                                     </div>
                                     <div class="calendarmenu">
                                         <!--<ul>
                                             <li class="menu-team-top">
                                                 <a [href]="googleCalendarEventUrl" target="_blank">Add To Calender</a>
                                             </li>
                                         </ul>-->

                                     </div>
                                 </div>
                                 <br />
                                 <div *ngIf="events$ | async;  let events">
                                     <div [ngSwitch]="view">
                                         <mwl-calendar-month-view *ngSwitchCase="'month'"
                                             [viewDate]="viewDate" [events]="events"
                                             [activeDayIsOpen]="activeDayIsOpen"
                                             (dayClicked)="dayClicked($event.day)"
                                             (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-month-view>
                                         <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
                                             [events]="events" (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-week-view>
                                         <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
                                             [events]="events" (eventClicked)="eventClicked($event.event)">
                                         </mwl-calendar-day-view>
                                     </div>
                                 </div>

                              </div>
                            </div>
                            <div class="fixture-season-tab-matches">
                               <div class="second-fixtures-detail-tab">
                                  <div class="second-fixtures-detail-tab-list">
                                     <ul class="subtab">
                                        <li class="fixtures-name ok" id="upcoming-{{subcat?.series_catagory_id}}"><a href="#" id="Upcoming">Upcoming Matches</a></li>
                                        <li class="fixtures-name " id="past-{{subcat?.series_catagory_id}}"><a href="#" id="Past">Past Matches</a></li>
                                     </ul>
                                  </div>
                               </div>
                               <div class="second-fixtures-detail-tab-detail fixtures-main-content ok" id="upcoming-{{subcat?.series_catagory_id}}-content">
                                    <div class="leicester-match-section cf">
                                        <div class="leicester-match-box" *ngFor="let upcoming of subcat?.upcoming_match" [ngStyle]="{'background-image':'url(' + upcoming?.image + ')'}">
                                            <div class="leicester-match-box-first">
                                               <h3>{{upcoming?.date_time | amDateFormat: "ddd"}}</h3>
                                               <h2>{{upcoming?.date_time | amDateFormat: "DD MMM"}}</h2>
                                               <h3>{{upcoming?.date_time |
                                                amDateFormat: "HH : mm a"}}</h3>
                                               <p>{{upcoming?.series_catagory_title}}</p>
                                            </div>
                                            <div class="leicester-match-box-left">
                                                <div class="leicester-match-box-left-logo-box">
                                                     <div class="leicester-match-left">
                                                         <div class="leicester-match-left-image">  
                                                            <img [src]="upcoming?.first_image">
                                                         </div>
                                                         <div class="leicester-match-left-team">
                                                            <h3>{{upcoming?.first_name}}</h3>
                                                         </div>
                                                      </div>
                                                      <div class="leicester-match-right">
                                                         <div class="leicester-match-left-image">  
                                                           <img [src]="upcoming?.second_image">
                                                         </div>
                                                         <div class="leicester-match-left-team">
                                                            <h3>{{upcoming?.second_name}}</h3>
                                                         </div>
                                                      </div>
                                                </div>
                                                <div class="leicester-match-box-left-content">
                                                      <p>{{upcoming?.location}}</p>
                                                </div>
                                            </div>
                                            <div class="leicester-match-box-right">
                                                <div class="leicester-match-box-right-btn">
                                                   <a href="{{upcoming?.redirect_url}}" target="_blank" *ngIf="upcoming?.redirect_url">Buy Tickets</a>
                                                   <a href="{{upcoming?.match_day_hospitality_url}}" target="_blank" *ngIf="upcoming?.match_day_hospitality_url">BUY HOSPITALITY</a>
                                                </div>
                                            </div>
                                            <div class="leicester-match-overlay"></div>
                                        </div>                                        
                                    </div>
                               </div>
                               <div class="second-fixtures-detail-tab-detail fixtures-main-content " id="past-{{subcat?.series_catagory_id}}-content">
                                  <div class="leicester-match-section cf">
                                    <div class="leicester-match-box" *ngFor="let past of subcat?.past_match" [ngStyle]="{'background-image':'url(' + past?.image + ')'}">
                                       <div class="leicester-match-box-first">
                                          <h3>{{past?.date_time | amDateFormat: "ddd"}}</h3>
                                          <h2>{{past?.date_time | amDateFormat: "DD MMM"}}</h2>
                                          <h3>{{past?.date_time |
                                           amDateFormat: "HH : mm a"}}</h3>
                                          <p>{{past?.series_catagory_title}}</p>
                                          <p *ngIf="past?.result">{{past?.result}}</p>
                                       </div>
                                       <div class="leicester-match-box-left">
                                           <div class="leicester-match-box-left-logo-box">
                                                <div class="leicester-match-left">
                                                    <div class="leicester-match-left-image">  
                                                       <img [src]="past?.first_image">
                                                    </div>
                                                    <div class="leicester-match-left-team">
                                                       <h3>{{past?.first_name}}</h3>
                                                    </div>
                                                 </div>
                                                 <div class="leicester-match-right">
                                                    <div class="leicester-match-left-image">  
                                                      <img [src]="past?.second_image">
                                                    </div>
                                                    <div class="leicester-match-left-team">
                                                       <h3>{{past?.second_name}}</h3>
                                                    </div>
                                                 </div>
                                           </div>
                                           <div class="leicester-match-box-left-content">
                                                 <p>{{past?.location}}</p>
                                           </div>
                                       </div>
                                       <div class="leicester-match-box-right">
                                          <div class="leicester-match-box-right-btn past" *ngIf="past?.series_type == 'TEST'">
                                             <a href="{{past?.day_1_url}}" target="_blank" *ngIf="past?.day_1_url">Day 1</a>
                                             <a href="{{past?.day_2_url}}" target="_blank" *ngIf="past?.day_2_url">Day 2</a>
                                             <a href="{{past?.day_3_url}}" target="_blank" *ngIf="past?.day_3_url">Day 3</a>
                                             <a href="{{past?.day_4_url}}" target="_blank" *ngIf="past?.day_4_url">Day 4</a>
                                              
                                           </div>
                                           <div class="leicester-match-box-right-btn past" *ngIf="past?.series_type == 'T20' || past?.series_type == 'ODI'">
                                             <a href="{{past?.day_1_url}}" target="_blank" *ngIf="past?.day_1_url">Match Report</a>
                                             <a href="{{past?.day_2_url}}" target="_blank" *ngIf="past?.day_2_url">Match Report</a>
                                             <a href="{{past?.day_3_url}}" target="_blank" *ngIf="past?.day_3_url">Match Report</a>
                                             <a href="{{past?.day_4_url}}" target="_blank" *ngIf="past?.day_4_url">Match Report</a>
                                              
                                           </div>
                                       </div>
                                       <div class="leicester-match-overlay"></div>
                                   </div>    
                                   
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!-- <div class="fixture-season-tab-content-bottom cf">
                            <div class="fixture-season-tab-content-bottom-detail">
                              <div class="fixture-season-tab-content-image"><img src="assets/images/bg9img.png"></div>
                              <div class="fixture-season-tab-content-text">
                                  <h2> 2021 Membership - On Sale Now</h2>
                                  <h4> A New Breed of Fox is here!</h4>
                                  <div class="fixture-season-content-text">
                                     <p> Leicestershire County Cricket Club announce the 2021 membership offering as part of the #ANewBreed campaign. A New Breed of Fox emphasises the new chapter of the club, both on and off the pitch. </p>
                                     <p> 2021 Memberships launch off the back of an encouraging 2020 season whereby, the Running Foxes reached the Quarter Finals of the Vitality Blast for the first time in 3 years. </p>
                                  </div>
                                  <div class="fixture-season-tab-content-text-btn"><a href="https://ticketing-lccc.crmporium.com/season-tickets.aspx" target="_blank">VIEW DETAILS</a></div>
                              </div>
                            </div>
                         </div> -->
                         <div class="fixture-season-tab-content-bottom cf" *ngIf="contentList">
                           <div class="fixture-season-tab-content-bottom-detail">
                              <div class="fixture-season-tab-content-image" *ngIf="contentList?.image"><img [src]="contentList?.image"></div>
                              <div class="fixture-season-tab-content-text">
                                 <h2 *ngIf="contentList?.title"> {{contentList?.title}}</h2>
                                 <h4 *ngIf="contentList?.sub_title"> {{contentList?.sub_title}}</h4>
                                 <div class="fixture-season-content-text" [innerHTML]="contentList?.description">
                                    <!-- <p> Leicestershire County Cricket Club announce the 2021 membership offering as part of the #ANewBreed campaign. A New Breed of Fox emphasises the new chapter of the club, both on and off the pitch. </p>
                                    <p> 2021 Memberships launch off the back of an encouraging 2020 season whereby, the Running Foxes reached the Quarter Finals of the Vitality Blast for the first time in 3 years. </p> -->
                                 </div>
                                 <div class="fixture-season-tab-content-text-btn" *ngIf="contentList?.button_url || contentList?.button_name"><a href="{{contentList?.button_url}}" target="_blank">{{contentList?.button_name}}</a></div>
                              </div>
                           </div>
                        </div>
                      </div>
                   </div>
                  
                </div>
             </div>
          </div>
          
       </div>
    </div>
 </section>
 